export default __webpack_public_path__ + "static/media/FinanceNewActive.f631b1d4.svg";